import { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../utils/storeApp";
import CallAPI from "../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";
import { CSVLink } from "react-csv";
import SharedMsg from "../SharedMsg";

const ListReceivedMessage = () => {
  const { userRole, userToken, sharedObject, SetSharedObject } = useUserStore(
    (state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [userObj, setUserObj] = useState([]);
  const [count, setCount] = useState(0);
  const [processing, SetProcessing] = useState(false);

  useEffect(() => {
    let obj = sharedObject.recievedMessageStatusResults;
    if (obj && Object.keys(obj).length > 0) {
      gridData(obj);
    }
  }, [sharedObject.recievedMessageStatusResults]);
  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/GetMessageStatus?sortBy=DateSent&sortDir=DESC&type=received&page=" +
      pg;
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      gridData(res.data.data);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const gridData = (obj) => {
    let cnt = obj.count;
    setCount(cnt);
    let tempObj = [];
    for (const row of obj.pageItems) {
      row.MDN = row.isMDN ? "MDN" : "Not MDN";
      row.dateSent = row.dateSent
        ? new Date(row.dateSent).toLocaleString("en-US", { hour12: false })
        : "";
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    getReport(sharedObject.messageStatusSearch, 1);
  };
  const headers = [
    { label: "Sent Date", key: "dateSent" },
    { label: "Sent From", key: "fromAddress" },
    { label: "Sent To", key: "sentAddress" },
    { label: "Message Type", key: "MDN" },
  ];
  const bulkDownLoad = () => {
    SetSharedObject("RecievedSearchType", "bulk");
    $("#recievedMsgSearchModal").modal("show");
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <main ref={componentRef} className="ListReceivedMessage">
        <header>
          <div className="spacer-inline sp-margin12">
            <h4 className="title-label3">Received Message</h4>
          </div>

          <div className="mid-header-bar spacer-inline sp-mx5">
            <button
              type="button"
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Open received message search"
              aria-haspopup="dialog"
              onClick={(e) => {
                SetSharedObject("RecievedSearchType", "reg");
                $("#recievedMsgSearchModal").modal("show");
              }}
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>

            <button
              type="button"
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Bulk download received messages"
              aria-haspopup="dialog"
              onClick={(e) => {
                bulkDownLoad();
              }}
            >
              <i className="bi bi-box-arrow-down" aria-hidden="true"></i>
            </button>

            {/*Reusable tools for reports*/}
            <div className="spacer-inline" role="toolbar" aria-label="Received message report export and refresh tools">
                <span className="SharedTools" role="group" aria-label="Export and print tools">
                    {count > 0 ? (
                      <CSVLink
                        filename="ReceivedMessageReport.csv"
                        className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                        aria-label="Download received messages as MS Excel CSV file"
                        data={userObj}
                        headers={headers}
                      >
                        <i className="bi bi-download" aria-hidden="true"></i>
                      </CSVLink>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled
                            aria-disabled="true"
                            aria-label="Download CSV (no results available)"
                          >
                            <i className="bi bi-download" aria-hidden="true"></i>
                       </button>
                    )}
              
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={count === 0} 
                    aria-disabled={count === 0}
                    aria-label={
                          count === 0
                            ? "Refresh report (no results to refresh)"
                            : "Refresh report"
                        }
                    onClick={(e) => {
                      if (count > 0) refreshPage();
                    }}
                  >
                    <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={count === 0} 
                    aria-disabled={count === 0}
                    aria-label={
                      count === 0
                        ? "Print report (no results to print)"
                        : "Print received messages report"
                    }
                    onClick={(e) => {
                      if (count > 0) handlePrint();
                    }}
                  >
                    <i className="bi bi-printer" aria-hidden="true"></i>
                  </button>
             </span>
            </div>
            <button
              type="button"
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-target="#MsgGuideModal"
              data-toggle="modal"
              aria-label="Open message status guide"
              aria-haspopup="dialog"
            >
              <i className="bi bi-chat-square-text" aria-hidden="true"></i>
            </button>
          </div>
        </header>
     
      <div>
        <section className="grid-header-bar" aria-label="Report filter summary">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
            <dl className="sp-mx7">
              <div className="spacer-inline spacer-margin1">
                <dt className="ft-wt">Domain:</dt>
                <dd className="sp-margin12 sp-mx7">
                  {sharedObject.messageStatusSearch.DomainName
                    ? sharedObject.messageStatusSearch.DomainName
                    : null}
                </dd>
              </div>
              <div className="spacer-inline">
                <dt className="ft-wt">Customer:</dt>
                <dd className="sp-margin12 sp-mx7">
                  {sharedObject.messageStatusSearch.VendorName
                    ? sharedObject.messageStatusSearch.VendorName
                    : null}
                </dd>
               </div>
              </dl>
            </>
          )}
          <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="ReceivedMessageReport">
              <DataTable
                value={userObj}
                aria-label="Received messages"
                paginator
                selectionPageOnly
                rows={25}
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="dateSent"
                sortOrder={-1}
              >
                <Column field="dateSent" header="Sent Date" className="w-md8" sortable></Column>
                <Column field="fromAddress" header="Sent From" className="truncate" sortable ></Column>
                <Column field="sentAddress" header="Sent To" className="truncate" sortable ></Column>
                <Column field="MDN" header="Message Type" sortable></Column>
              </DataTable>
            </div>
          ) : (
            <div 
                className="empty-grid"
                role="status"
                aria-live="polite"
                aria-atomic="true"
            >
              There are currently no search results.
            </div>
          )}
        </section>
        
        {processing && (
          <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="list-receivedmessage-loader"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="list-receivedmessage-loader">{loadingText}</div>
          </div>
        )}
      </div>
    </main>
  );
};

export default ListReceivedMessage;
